/*
 * @Descripttion:
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-05 20:23:32
 * @LastEditors: ???
 * @LastEditTime: 2022-05-14 14:39:23
 */
import request from '@/utils/request';

// 查询系统角色列表
export function getRoleListAll() {
  return request({
    url: '/role/getRoleListAll',
    method: 'post',
  });
}
// 对用户名进行验证
export function findByuserName(data) {
  return request({
    url: `/user/findByuserName?userName=${data.userName} &userId=${data.userId}`,
    method: 'get',
  });
}

// 手机号进行验证
export function findByMobile(data) {
  return request({
    url: `/user/findByMobile?mobile=${data.mobile} &userId=${data.userId} &mobileType=${data.mobileType}`,
    method: 'get',
  });
}

// 忘记密码 重置密码
export function emailResetPassword(data) {
  return request({
    url: `/user/updatePassword?userId=${data.userId} &password=${data.password}`,
    method: 'post',
  });
}
